var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Paymentdetails2s.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2bd2403b\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Paymentdetails2s.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Paymentdetails2s/Paymentdetails2s.vue
// module id = 1185
// module chunks = 0